import { Component, OnInit, HostBinding, Output, EventEmitter, TemplateRef, Input, ViewChild, ComponentFactoryResolver, Injector, AfterViewInit, Inject, Optional, ChangeDetectorRef, LOCALE_ID } from '@angular/core';
import { TypeConverter } from '@farris/ide-property-panel';
import { ActivityComponentRepository } from './activity-component.repository';
import { ActivityComponentUIState } from './activity-component.uistate';
import { ActivityComponentViewModel } from './activity-component.viewmodel';
import { BizComponentEntity } from '../../domain/entities/biz-component.entity';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { ExprEditMode, ExpressionService, InjectedType, VarEntity } from '@gsp-svc/expression';
import { BsModalService } from '@farris/ui-modal';
import { SelectorResult, CommonComponentUiRTService } from '@gsp-cmp/ccmp-ui';
import { GspComponent } from '@gsp-cmp/common-component';
import { DataColumn, DatagridComponent } from '@farris/ui-datagrid';
import { forkJoin, of } from 'rxjs';
import { EditorTypes } from '@farris/ui-datagrid-editors';
import { MessagerService } from '@farris/ui-messager';
import { EditComponentParameterComponent } from '../edit-component-parameter/edit-component-parameter.component';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'app-activity-component',
  templateUrl: './activity-component.component.html',
  styleUrls: ['./activity-component.component.scss'],
  providers: [ActivityComponentRepository, ActivityComponentUIState, ActivityComponentViewModel,
     WfLocalePipe,
  ]
})
export class ActivityComponentComponent implements OnInit, AfterViewInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';
  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();
  @Input() editorParams: any = {};
  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  @ViewChild('buttonsTemplate') btnTemplate: TemplateRef<any>;
  @ViewChild('cmplist') cmplist: DatagridComponent;
  @ViewChild('paramlist') paramlist: DatagridComponent;
  exBizTips = false;
  modalConfig = {
    title: this.localePipe.transform('component.activityComponent.component'),
    width: 960,
    height: 506,
    showButtons: true
  };
  @Input()
  set value(cpts: any[]) {
    if (cpts && cpts.length > 0) {
      let metaDataIdList = new Array();
      for (const cmp of cpts) {
        if (metaDataIdList.indexOf(cmp.metadataId) == -1) {
          metaDataIdList.push(cmp.metadataId);
        }
      }
      if (metaDataIdList.length > 0) {
        forkJoin(metaDataIdList.map((metaDataId: string) => this.designerState.getHelpMetaData(metaDataId, ''))).subscribe(cmpMetas => {
          for (const cpt of cpts) {
            const bizComponent = new BizComponentEntity(cpt.name, cpt.metadataId, cpt.methodCode);
            bizComponent.executionTime = cpt.executionTime,
            bizComponent.id = cpt.id;
            bizComponent.isForCompensation = cpt.isForCompensation;
            bizComponent.actualParameters = new Array();
            bizComponent.scopeType = cpt.scopeType || null;

            const meta = cmpMetas.find(m => m.id === cpt.metadataId);
            const content = JSON.parse(meta.content);
            const operation = content.operations.find(o => o.code === cpt.methodCode);
            if (operation) {
              bizComponent.actualParameters = cpt.actualParameters.map(a => {
                const p = operation.parameters.find(i => i.code === a.code);
                if (p) {
                  return {
                    code: a.code,
                    name: a.name,
                    value: a.value,
                    required: a.code.toLowerCase() ==='wfcontext'? false : p.required
                  };
                } else {
                  console.error(this.localePipe.transform('component.activityComponent.method') + cpt.methodCode + this.localePipe.transform('component.activityComponent.inconsistentParameters'));
                  return {
                    code: a.code,
                    name: a.name,
                    value: a.value,
                    required: false
                  };
                }
              });
            } else {
              console.error(this.localePipe.transform('component.activityComponent.longerExists') + cpt.methodCode + this.localePipe.transform('component.activityComponent.pleaseCheck'));
            }
            this.uistate.components.push(bizComponent);
          }
        });
      }
    }
  }

  buttonGroupData = [
    {
      id: 'edit',
      text: this.localePipe.transform('component.activityComponent.edit'),
    },
    {
      id: 'deleteRow',
      text: this.localePipe.transform('component.activityComponent.deleteRow'),
    }
  ];
  editState = 'new'; // 编辑状态，用于区分是新增还是编辑  new | edit
  isPreExternalProcessCmps = false;
  location: 'activity' | 'process' | 'autoActivity';
  columns = [];
  paramColumns = [];
  constructor(
    public uistate: ActivityComponentUIState,
    public viewModel: ActivityComponentViewModel,
    private designerState: ProcessDesignerUIState,
    private expr: ExpressionService,
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private modalService: BsModalService,
    private componentService: CommonComponentUiRTService,
    private repository: ActivityComponentRepository,
    private message: MessagerService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
  }

  ngOnInit() {
    // 2023-5-25 网速慢的时候会导致加载不出来流程构件，因此加个延时
    setTimeout(() => {
      this.restart();
    }, 300)
  }

  restart() {
    if (this.designerState.startMode === 'EXTERNAL_PROCESS') {
      this.repository.getBizCmp((cmps) => {
        if (cmps && cmps.length > 0) {
          // 此处标记有外部流程通用构件
          for (const c of cmps) {
            if (c.scopeType === 'ExternalProcess') {
              this.exBizTips = true;
              break;
            }
          }
        }
      });
    }
    this.location = this.editorParams.location;
    if (this.location === 'activity') {
      this.uistate.executionCollection = this.uistate.activityCollection;
      this.columns = [
        {
          field: 'executionTime', width: 100, title: this.localePipe.transform('component.activityComponent.executionTime'),
          editor: {
            type: EditorTypes.COMBOLIST,
            options: { data: this.uistate.executionCollection, groupField: 'text', valueField: 'value', textField: 'text', idField: 'value', panelHeight: 'auto' }
          },
          formatter: (v, d, i) => {
            if (v) {
              return this.uistate.executionCollection.find(item => item.value === v).text;
            } else {
              return '';
            }
          },
          validators: [
            { type: 'required', messager: '必填' }
          ]
        },
        {
          field: 'name', width: 100, title: this.localePipe.transform('component.activityComponent.cmpName')
        },
        { field: 'metadataId', width: 100, title: this.localePipe.transform('component.activityComponent.metadataId') },
        { field: 'methodCode', width: 100, title: this.localePipe.transform('component.activityComponent.methodCode') },
        {
          field: 'isForCompensation', width: 50, title: this.localePipe.transform('component.activityComponent.isForCompensation'),
          editor: { type: EditorTypes.SWITCH, options: {} },
          formatter: { type: 'boolean', options: { trueText: this.localePipe.transform('component.activityComponent.yes'), falseText: this.localePipe.transform('component.activityComponent.no') } }
        },
        { title: this.localePipe.transform('component.activityComponent.operate'), width: 70, template: this.btnTemplate }
      ];
    } else if (this.location === 'autoActivity') {
      this.columns = [
        {
          field: 'name', width: 100, title: this.localePipe.transform('component.activityComponent.cmpName')
        },
        { field: 'metadataId', width: 100, title: this.localePipe.transform('component.activityComponent.metadataId') },
        { field: 'methodCode', width: 100, title: this.localePipe.transform('component.activityComponent.methodCode') },
        {
          field: 'isForCompensation', width: 50, title: this.localePipe.transform('component.activityComponent.isForCompensation'),
          editor: { type: EditorTypes.SWITCH, options: {} },
          formatter: { type: 'boolean', options: { trueText: this.localePipe.transform('component.activityComponent.yes'), falseText: this.localePipe.transform('component.activityComponent.no') } }
        },
        { title: this.localePipe.transform('component.activityComponent.operate'), width: 70, template: this.btnTemplate }
      ];
    } else {
      this.columns = [
        {
          field: 'executionTime', width: 100, title: this.localePipe.transform('component.activityComponent.executionTime'),
          editor: {
            type: EditorTypes.COMBOLIST,
            options: { data: this.uistate.executionCollection, groupField: 'text', valueField: 'value', textField: 'text', idField: 'value', panelHeight: 'auto' }
          },
          formatter: (v, d, i) => {
            if (v) {
              return this.uistate.executionCollection.find(item => item.value === v).text;
            } else {
              return '';
            }
          },
          validators: [
            { type: 'required', messager: '必填' }
          ]
        },
        {
          field: 'name', width: 100, title: this.localePipe.transform('component.activityComponent.cmpName')
        },
        { field: 'metadataId', width: 100, title: this.localePipe.transform('component.activityComponent.metadataId') },
        { field: 'methodCode', width: 100, title: this.localePipe.transform('component.activityComponent.methodCode') },
        { title: this.localePipe.transform('component.activityComponent.operate'), width: 70, template: this.btnTemplate }
      ];
    }
    if (this.uistate.components && this.uistate.components.length > 0) {
      this.cmplist.selectRow(this.uistate.components[0].id, true);
    }

    this.paramColumns = [
      { field: 'code', width: 50, title: this.localePipe.transform('component.activityComponent.code') },
      { field: 'name', width: 50, title: this.localePipe.transform('component.activityComponent.name') },
      {
        field: 'value', width: 100, title: this.localePipe.transform('component.activityComponent.value') ,
        editor: {
          type: 'input-group',
          options: {
            groupText: '<i class="f-icon f-icon-lookup"></i>',
            editable: false,
            clickHandle: (e) => {
              e.formControl.setValue(e.instance.value ? e.instance.value : '');
              this.showExprHelp(e);
            },
            clear: (e) => {
              console.log('clear', e);
            }
          }
        }
      }
    ];
    // 选中当前行
    this.repository.subject.subscribe(cmp => {
      this.cmplist.loadData(this.uistate.components);
      if (cmp) {
        this.cmplist.selectRow(cmp.id, true);
      } else {
        this.uistate.curComponent = null;
      }
    });
  }

  ngAfterViewInit() {
    if (this.uistate.components && this.uistate.components.length > 0) {
      this.cmplist.selectRow(this.uistate.components[0].id, true);
    }
  }
  edit() {
    this.editState = 'edit';
    const compFactory = this.resolver.resolveComponentFactory(EditComponentParameterComponent);
    const compRef = compFactory.create(this.injector);
    const modalConfig = {
      title: this.localePipe.transform('component.activityComponent.editComponent'),
      width: 700,
      height: 400,
      buttons: compRef.instance.editFooter,
      showButtons: true,
      initialState: {
        curComponent: JSON.parse(JSON.stringify(this.uistate.curComponent))
      }
    };
    const editDialog = this.modalService.show(compRef, modalConfig);
    compRef.instance.canEdit = false;
    compRef.instance.editState = this.editState;
    compRef.instance.location = this.location;
    compRef.instance.executionTimingList = this.uistate.executionCollection;
    // compRef.instance.curComponent = JSON.parse(JSON.stringify(this.uistate.curComponent));
    compRef.instance.submitEmitter.subscribe(cmp => {
      const i = this.uistate.components.findIndex(item => item.id === cmp.id);
      this.uistate.components[i] = cmp;
      this.cmplist.loadData(this.uistate.components);
      editDialog.close()
    });
    compRef.instance.closeEmitter.subscribe(re => {
      editDialog.close()
    });
    setTimeout(() => {
      compRef.instance.cd.detectChanges();
    })
  }
  deleteRow() {
    this.message.confirm(this.localePipe.transform('component.activityComponent.confirmDelete')).subscribe((v) => {
      if (v) {
        this.closeCellEdit();
        this.viewModel.deleteRow();
        this.cmplist.loadData(this.uistate.components);
      }
    });
  }
  moveUp() {
    if (!this.uistate.curComponent) {
      this.message.info(this.localePipe.transform('component.activityComponent.curComponent'));
      return;
    }
    const curCmpId: string = this.uistate.curComponent.id;
    const i = this.uistate.components.findIndex(c => c.id === curCmpId);
    if (i === 0) {
      return;
    }
    this.repository.swapArray(this.uistate.components, i, i - 1);

    this.cmplist.loadData(this.uistate.components);
    this.cmplist.selectRow(curCmpId, true);
  }

  moveDown() {
    if (!this.uistate.curComponent) {
      this.message.info(this.localePipe.transform('component.activityComponent.curComponent'));
      return;
    }
    const curCmpId: string = this.uistate.curComponent.id;
    const i = this.uistate.components.findIndex(c => c.id === curCmpId);
    if (i === this.uistate.components.length - 1) {
      return;
    }
    this.repository.swapArray(this.uistate.components, i, i + 1);

    this.cmplist.loadData(this.uistate.components);
    this.cmplist.selectRow(curCmpId, true);
  }

  clickAction(buttonId: string, ctx: any) {
    this.uistate.curComponent = ctx.rowData;
    switch (buttonId) {
      case 'edit':
        this.edit();
        break;
      case 'deleteRow':
        this.deleteRow();
        break;
    }
  }

  clickOK() {
    this.closeCellEdit();
    if (this.validator()) {
      const object = { value: this.uistate.components, parameters: null };
      this.submitModal.emit(object);
    }
  }

  clickCancel() {
    this.closeModal.emit();
  }
  componentSelect() {
    this.editState = 'new';
    const compFactory = this.resolver.resolveComponentFactory(EditComponentParameterComponent);
    const compRef = compFactory.create(this.injector);
    const modalConfig = {
      title: this.localePipe.transform('component.activityComponent.newComponent'),
      width: 700,
      height: 400,
      buttons: compRef.instance.editFooter,
      showButtons: true
    };
    const editDialog = this.modalService.show(compRef, modalConfig);
    compRef.instance.canEdit = true;
    compRef.instance.editState = this.editState;
    compRef.instance.location = this.location;
    compRef.instance.executionTimingList = this.uistate.executionCollection;
    compRef.instance.curComponent = new BizComponentEntity();
    compRef.instance.submitEmitter.subscribe(cmp => {
      //防抖  id是随机生成的，所以只有快速双击的时候才会有id相同的情况
      if(this.uistate.components && this.uistate.components.length > 0) {
        if(this.uistate.components.some(component => component.id === cmp.id)) {
          return;
        }
      }
      this.uistate.components.push(cmp);
      this.cmplist.loadData(this.uistate.components);
      editDialog.close()
    });
    compRef.instance.closeEmitter.subscribe(re => {
      editDialog.close()
    });
    setTimeout(() => {
      compRef.instance.cd.detectChanges();
    })
  }
  /**
   * 取数构件帮助new
   */
  openComponentSelectorNew(metadataId: string, sessionId: string) {
    this.componentService.openSelector(metadataId, sessionId).subscribe(
      (selectorResult: SelectorResult) => {
        selectorResult.confirmEvent.subscribe(
          (result: GspComponent) => {
            this.viewModel.componentSelect(result);
          });
      });
  }
  showExprHelp(e: any) {
    let context = new Array<VarEntity>();
    // if(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage')) {
    //   context.push(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage'));
    // }
    // this.expr.clearContext();
    if (this.designerState.schemas.length > 0) {
      for (const schema of this.designerState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerState.schemas[0].entityTypes && this.designerState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    context = this.designerState.addContext(context);
    if (this.location === 'activity') {
      for (const variable of this.designerState.activityComponentContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.location === 'activity') {
      for (const variable of this.designerState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    this.expr.setEditPattern(ExprEditMode.Advanced); // 默认打开高级表达式编辑器
    this.expr.addExpressionText(e.instance.value);
    this.expr.buildExpression().then((expressioninfo: string) => {
      e.formControl.setValue(expressioninfo);
      e.instance.cd.detectChanges();
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }
  selectionChange(data: any) {
    this.uistate.curComponent = data.data;
  }
  paramAfterEdit = (rowIndex: number, rowData: any, column?: DataColumn) => {
    return of(true);
  }

  private closeCellEdit() {
    this.cmplist.endCellEdit();
    if (this.paramlist) {
      this.paramlist.endCellEdit();
    }
  }

  private validator(): boolean {
    // 校验是否存在重复的构件
    const cache = [];
    for (const cmp of this.uistate.components) {
      if (cache.find(c => c.methodCode === cmp.methodCode && JSON.stringify(c.actualParameters) === JSON.stringify(cmp.actualParameters) &&
        c.executionTime === cmp.executionTime)) {
        console.log(cmp.actualParameters);
        this.message.warning(this.localePipe.transform('component.activityComponent.sameCmp') + `${cmp.name}` + this.localePipe.transform('component.activityComponent.cmpMethod')+ cmp.methodCode + this.localePipe.transform('component.activityComponent.pleaseCheck'));
        return false;
      }
      cache.push(cmp);
      if (!cmp.executionTime && this.location !== 'autoActivity') {
        this.message.warning(this.localePipe.transform('component.activityComponent.executionTimeNotNull'));
        return false;
      }
      for (const param of cmp.actualParameters) {
        if (param.required && !param.value) {
          this.message.warning(this.localePipe.transform('component.activityComponent.component') + `【${cmp.name}】` + this.localePipe.transform('component.activityComponent.param') + `【${param.code}】` + this.localePipe.transform('component.activityComponent.required'));
          return false;
        }
      }
    }
    return true;
  }
}

export class ActivityComponentConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any[]): string {
    if (data && data.length > 0) {
      return this.localePipe.transform("component.activityComponent.set");
    } else {
      return this.localePipe.transform("component.activityComponent.notSet");
    }
  }
}
